import React from 'react';
import { Typography, Row } from 'antd';
import globalStyles from 'common/global.module.scss';
import { formatLongDate } from 'common';

const { Text } = Typography;

const TaxTraxDisclaimer: React.FC = () => {
  return (
    <>
      <Row type="flex" justify="center">
        <Text strong={true} className={globalStyles.textCenter}>
          Note: Incorporated Village Taxes and/or Special Assessments, if any,
          are not included unless otherwise shown herein and may not be included
          in their entirety.
        </Text>
        <br />
        <br />
        <Text strong={true} className={globalStyles.textCenter}>
          This report is intended for informational purposes only and DataTrace
          disclaims any and all liability to any person or entity for the
          information reported herein.
        </Text>
        <Text strong={true} className={globalStyles.textCenter}>
          BALANCE DUE amounts may be subject to additional interest/penalties
          and/or fees.
        </Text>
      </Row>
      <Row type="flex" justify="center">
        <Text strong={true}>Generated: {formatLongDate(new Date())}</Text>
      </Row>
    </>
  );
};

export default TaxTraxDisclaimer;
